import CryptoJS from 'crypto-js';

export const encrypt = (plainText = null) => {
    if (!plainText) 
        return null;

    // Generiere einen zufälligen IV
    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(
        plainText,
        CryptoJS.enc.Utf8.parse(process.env.EXPO_PUBLIC_CRYPT_KEY),
        {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        }
    );

    // Kombiniere IV und Ciphertext
    const combined = iv.clone().concat(encrypted.ciphertext);

    // Base64 kodieren und Zeichen ersetzen wie in decryptResponse
    let base64 = CryptoJS.enc.Base64.stringify(combined);
    base64 = base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');

    return base64;
};